<template>
  <div>
    <div class="d-flex justify-content-between align-items-center pt-50 mb-2">
      <div class="d-flex align-items-center">
        <span @click="$router.go(-1)">
          <b-button
            variant="white"
            class="btn-icon rounded-circle mr-50 text-primary bg-white"
            size="sm"
          >
            <feather-icon icon="ChevronLeftIcon" />
          </b-button>
        </span>
        <h2 class="font-weight-bolder m-0 mr-2">
          Notificaciones
        </h2>
      </div>
      <b-button
        variant="primary"
        class="ml-2"
        @click="addNotify"
      >
        Añadir notificación
      </b-button>
    </div>
    <b-card class="mb-2 p-2">
      <div class="mb-2">
        <p><strong>Indica las notificaciones que recibirá el trabajador en su aplicación.</strong></p>
        <p class="text-muted small mb-2">
          Esta notificación sólo se recibirá en los usuarios con la jornada en progreso.
        </p>
      </div>
      <b-row>
        <b-col cols="12">
          <transition-group
            name="fade"
            tag="div"
          >
            <b-card
              v-for="(notify, index) in notifications"
              :key="index"
              class="mb-2 notification-card border shadow-sm"
            >
              <div class="d-flex align-items-center justify-content-between mb-2 notification-header">
                <div class="d-flex align-items-center flex-grow-1">
                  <feather-icon
                    icon="BellIcon"
                    class="text-primary mr-1"
                    size="18"
                  />
                  <span class="font-weight-bold mr-2">Notificación {{ index + 1 }}</span>
                </div>
                <div class="d-flex align-items-center mr-2">
                  <b-form-timepicker
                    v-model="notify.hour"
                    local="es"
                    :no-close-button="true"
                    :hide-header="true"
                    :minutes-step="5"
                  />
                </div>
                <b-button
                  variant="link"
                  class="p-0 text-danger remove-btn ml-2"
                  title="Eliminar notificación"
                  @click="removeNotify(index)"
                >
                  <feather-icon
                    icon="TrashIcon"
                    size="18"
                  />
                </b-button>
              </div>
              <b-row>
                <b-col sm="6">
                  <b-form-group
                    label="Título"
                    label-for="notify-title"
                  >
                    <b-form-input
                      v-model="notify.title"
                      name="title"
                      placeholder="Título"
                    />
                  </b-form-group>
                </b-col>
                <b-col sm="6">
                  <b-form-group
                    label="Texto"
                    label-for="notify-body"
                  >
                    <b-form-input
                      v-model="notify.body"
                      name="body"
                      placeholder="Texto de la notificación"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
            </b-card>
          </transition-group>
        </b-col>
        <b-col
          cols="12"
          class="text-right mt-2"
        >
          <b-button
            type="submit"
            variant="primary"
            class="mt-1 px-4"
            @click="saveNotifications"
          >
            Guardar
          </b-button>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import {
  BButton, BRow, BCol, BCard, BFormGroup, BFormTimepicker, BFormInput,
} from 'bootstrap-vue'

export default {
  components: {
    BButton,
    BRow,
    BCol,
    BCard,
    BFormGroup,
    BFormTimepicker,
    BFormInput,
  },
  computed: {
    ...mapGetters({
      calendar: 'calendar/getCalendar',
    }),
  },
  data() {
    return {
      notifications: [],
    }
  },
  methods: {
    ...mapActions({
      editCalendar: 'calendar/edit',
      getCalendar: 'calendar/getCalendar',
    }),
    addNotify() {
      this.notifications.push({
        hour: '00:00:00',
        title: '',
        body: '',
      })
    },
    removeNotify(index) {
      this.notifications.splice(index, 1)
    },
    loadNotifications() {
      if (this.calendar.notifications_push) {
        try {
          const arr = JSON.parse(this.calendar.notifications_push)
          this.notifications = arr.map(n => (typeof n === 'string' ? JSON.parse(n) : n))
        } catch (e) {
          this.notifications = []
        }
      }
    },
    async saveNotifications() {
      const data = new FormData()
      data.append('notifications_push', JSON.stringify(this.notifications))
      data.append('type_journey', this.calendar.type_journey)
      await this.editCalendar({ calendar: data })
    },
  },
  async created() {
    await this.getCalendar()
    this.loadNotifications()
  },
}
</script>

<style scoped>
  .notification-header {
    gap: 0.5rem;
  }
  .notification-card {
    border-radius: 0.75rem;
    box-shadow: 0 2px 8px rgba(0,0,0,0.04);
    border: 1.5px solid #e3e7ed;
    background: #fff;
    transition: box-shadow 0.2s, border-color 0.2s;
  }
  .notification-card:hover {
    box-shadow: 0 4px 16px rgba(0,0,0,0.08);
    border-color: #b3c2db;
  }
  .remove-btn {
    transition: color 0.2s;
  }
  .remove-btn:hover {
    color: #d9534f !important;
  }
  .fade-enter-active, .fade-leave-active {
    transition: all 0.3s;
  }
  .fade-enter, .fade-leave-to {
    opacity: 0;
    transform: translateY(10px);
  }
</style>
